module.exports = __webpack_public_path__ + "img/on-the-go-people-2x.282a7658.jpg";